const validateTrip = (formState)=> {
    let form = {};
    if (!formState.vehicleNo || !formState.startTime || !formState.endTime) {
        form._error = "Required field missing";
        form.invalid = true;
    }
    return form;
};
export  default validateTrip;